<template lang="pug">
  div.award-levitated-sphere-container(@click="handleBubbleClick" v-platform-expose="moduleExpose")
    .award-levitated-sphere-coin(
      :class="awardInfo.className"
    )
      .award-coin-account(v-if="awardStatus !== 'NORMAL'") {{ rewardCount }}
      img.award-coin-normal(
        v-if="awardStatus === AWARD_COIN_STATUS.NORMAL"
        src="https://m.hellobike.com/079de37e_B.png"
      )

      .award-levitated-sphere-title(
        :class="{ 'not-normal-title': awardStatus !== AWARD_COIN_STATUS.NORMAL }"
      ) 单单返
      .award-levitated-sphere-past-due(v-if="awardStatus === AWARD_COIN_STATUS.PAST_DUE")

    //- 手指动画
    template(v-if="showFinger")
      Lottie.finger-lottie(
        url="https://m.hellobike.com/resource/helloyun/08345/DAcMKLrQ3U.json"
      )
</template>

<script>
import SPM from '@/pages/welfare/common/spm';
import { AWARD_COIN_STATUS, AWARD_COIN_STATUS_MAP } from '@/pages/welfare/consts';

export default {
  name: 'AwardLevitatedSphere',
  components: {
    Lottie: () => import('@/components/lottie'),
  },
  props: {
    // 单单返币奖励金数量
    rewardCount: {
      type: Number,
      default: 0,
    },
    // 单单返奖励金是否即将过期
    isDueSoon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AWARD_COIN_STATUS,
      // 手指动画是否显示
      showFinger: false,
      // 领取状态
      awardStatus: AWARD_COIN_STATUS.NORMAL,
      // 不同状态配置信息
      awardInfo: {},
    };
  },
  watch: {
    rewardCount: {
      handler() {
        let awardStatus = AWARD_COIN_STATUS.NORMAL;
        if (this.rewardCount) {
          awardStatus = this.isDueSoon
            ? AWARD_COIN_STATUS.PAST_DUE
            : AWARD_COIN_STATUS.AWARD;
          this.showFinger = true;
        }

        this.awardStatus = awardStatus;
        this.awardInfo = AWARD_COIN_STATUS_MAP[awardStatus];
      },
      immediate: true,
    },
  },
  methods: {
    moduleExpose() {
      // 曝光悬浮球埋点
      const exposeModuleId = this.rewardCount ? 'bonus_toreceive' : 'ordertask_bonus';
      SPM.moduleExpose({
        moduleId: exposeModuleId,
        contentId: exposeModuleId,
        businessInfo: {},
      });
    },
    // 悬浮球点击
    handleBubbleClick() {
      this.showFinger = false;
      this.$emit('awardClick', this.awardStatus);

      // 点击悬浮球埋点
      const exposeModuleId = this.rewardCount ? 'bonus_toreceive' : 'ordertask_bonus';
      SPM.clickButton({
        buttonName: exposeModuleId,
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.award-levitated-sphere-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  // 阴影动画：与球的运动方向相反
  // 0%/100%：初始位置；50%：球上浮时阴影下移+变大
  @keyframes floatShadow {
    0%,
    100% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.1);
    }
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-0.05rem);
    }
  }

  .award-levitated-sphere-coin {
    padding-top: 0.1rem;
    width: 0.64rem;
    height: 0.64rem;
    background: url('https://m.hellobike.com/6737212e_bubble%20(1).png') no-repeat center center;
    background-size: contain;
    animation: float 2s ease-in-out infinite;
    display: flex;
    flex-direction: column;
    align-items: center;

    @keyframes move-light {
      100% {
        left: 170%;
      }
    }

    .award-coin-account {
      font-family: 'DIN Alternate Bold', sans-serif;
      font-size: 0.2rem;
      height: 0.23rem;
      line-height: 0.23rem;
      font-weight: 700;
      color: #662800;
      margin-top: 0.02rem;
    }

    .award-coin-normal {
      width: 0.27rem;
      height: 0.21rem;
      margin-top: 0.02rem;
      margin-bottom: 0.02rem;
    }
  }

  .award-levitated-sphere-title {
    font-size: 0.09rem;
    line-height: 0.13rem;
    height: 0.13rem;
    font-weight: 400;
    color: #7f3200;

    &.not-normal-title {
      margin-top: -0.02rem;
    }
  }

  .award-levitated-sphere-past-due {
    background: url("https://m.hellobike.com/10be8352cd.png") no-repeat center center;
    background-size: contain;
    width: 0.36rem;
    height: 0.13rem;
    margin-top: -0.01rem;
  }

  .finger-lottie {
    position: absolute;
    top: 0.01rem;
    right: -0.18rem;
    z-index: 1;
    width: 1.6rem;
  }
}
</style>
